/**
 * uriPatterns一覧と照合し、マッチするURIがあるか判定する
 */
export function matchesURIPattern(uri: string): boolean {
  if (!uri) return false;

  const uriPatterns = ['/traversal/nursing-homes/:nursingHomeId', '/traversal/md/nursing-homes/:nursingHomeId'];

  return uriPatterns.some((pattern) => {
    const regexPattern = pattern.replace(/:[^/]+/g, '\\d+');
    const regex = new RegExp(regexPattern);
    console.log(regex.test(uri));
    return regex.test(uri);
  });
}
